import axios from "axios";
import React, { useEffect, useState } from "react";
import { Navigate, useSearchParams } from "react-router-dom";
import http from "../Http";
import "../assets/style/pages/Login.scss";
import Loading from "../components/Loading";
import {
  AUTH_ENDPOINTS,
  BASE,
  PAGES_ENDPOINTS,
  REDIRECT,
} from "../constants/Endpoints";
import { useUserInfo } from "../providers/UserProvider";
import { processAccessTokenResponse } from "../utils/Auth";

const STATE_STORAGE = "state";

/**
 * This function saves the generated state in localStorage.
 * @param {String} state
 */
const saveState = (state) => {
  localStorage.setItem(STATE_STORAGE, state);
};

/**
 * This function fetches the state string from localStorage.
 * @returns state as String or null if not found
 */
export const getState = () => {
  return localStorage.getItem(STATE_STORAGE);
};

/**
 * This function initializes the process for the login.
 * @param {React.props} props
 * @returns React Component
 */
export default function Login() {
  const { isAuthenticated, dispatch } = useUserInfo();
  const [loading, setLoading] = useState(false);
  const [searchParams, setSearchParams] = useSearchParams();

  useEffect(() => {
    const code = searchParams.get("code");
    const error = searchParams.get("error");

    if (code) {
      processAuthCode(code);
    }

    if (error != null) {
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [searchParams]);

  const processAuthCode = async (code) => {
    searchParams.delete("code");
    searchParams.delete("state");
    setSearchParams(searchParams);
    setLoading(true);
    const accessTokenResponse = await axios.post(AUTH_ENDPOINTS.TOKEN, null, {
      params: { code },
    });
    if (processAccessTokenResponse(accessTokenResponse)) {
      const userResponse = await http.get(AUTH_ENDPOINTS.USER);
      dispatch({ type: "AUTHENTICATED", userInfo: userResponse.data });
    }
  };

  if (isAuthenticated) return <Navigate to={PAGES_ENDPOINTS.MAIN} />;

  // Generate a state and use it in case one does not already exist
  let state = getState() ? getState() : Math.random().toString(36).slice(2);
  if (!getState()) saveState(state);

  return (
    <>
      <div className="center-container">
        <div className="center-cell">
          <section className="login">
            <img className="center" src="/logo.png" alt="logo" />
            <h2 className="center">
              Inloggen <small>bij Studyplanner</small>
            </h2>
            {loading ? <Loading /> : null}
            {/*  {message?.type && <Message message={message} />}*/}
            <button
              className="kennisnet_btn"
              onClick={() => {
                const slc = searchParams.get("slc");
                if (slc) {
                  searchParams.delete("slc");
                  setSearchParams(searchParams);
                }
                let loginUrl =
                  BASE +
                  AUTH_ENDPOINTS.KENNISNET +
                  "?redirect_uri=" +
                  REDIRECT +
                  "&state=" +
                  state;
                if (slc) {
                  loginUrl += "&slc=" + slc;
                }
                window.location.href = loginUrl;
              }}
              disabled={loading}
            >
              Inloggen met Kennisnet
            </button>
          </section>
        </div>
      </div>
    </>
  );
}
